import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PinkImageFallbackProps = {
  ariaLabel?: string;
  ariaHidden?: boolean;
  headline?: string | null;
  footer?: string | null;
  topLabel?: string | null;
  icon?: ReactNode;
  className?: string;
  contentClassName?: string;
};

export function PinkImageFallback({
  ariaLabel,
  ariaHidden,
  headline,
  footer,
  topLabel,
  icon,
  className,
  contentClassName
}: PinkImageFallbackProps) {
  const label = ariaLabel ?? headline ?? "Image unavailable";

  return (
    <div
      role="img"
      aria-hidden={ariaHidden}
      aria-label={label}
      className={cn("local-buzz-theme relative overflow-hidden bg-blush text-blush-foreground", className)}
    >
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage: "radial-gradient(circle at 30% 30%, currentColor 1px, transparent 1.4px)",
          backgroundSize: "14px 14px"
        }}
      />
      {topLabel ? (
        <div className="absolute left-5 top-5 z-10 text-[10px] font-bold uppercase tracking-[0.22em] text-brand">
          {topLabel}
        </div>
      ) : null}
      <div className={cn("relative flex h-full flex-col justify-end p-5 pt-16", contentClassName)}>
        {icon ? <div className="mb-auto grid h-12 w-12 place-items-center rounded-full bg-brand/15 text-brand">{icon}</div> : null}
        {headline ? (
          <div className="font-script text-3xl leading-[1.05] text-brand line-clamp-2">
            {headline}
          </div>
        ) : null}
        {footer ? (
          <div className="mt-2 text-[10px] font-bold uppercase tracking-[0.22em] opacity-70">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
